import React, { createContext, useState, useEffect, useContext } from "react";
import { loginApi, getMeApi } from "./service/api_service";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const res = await getMeApi(token);
          const userData = res.data.user;
          setUser(userData);
          if (!localStorage.getItem("selected_branch_id") && userData?.default_branch_id) {
            localStorage.setItem("selected_branch_id", userData.default_branch_id.toString());
          }
        } catch (error) {
          console.error("Token invalid or expired", error);
          localStorage.removeItem("token");
          localStorage.removeItem("selected_branch_id");
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const login = async (username, password) => {
    const res = await loginApi(username, password);
    localStorage.setItem("token", res.data.token);
    const userData = res.data.user;
    setUser(userData);
    if (userData?.default_branch_id) {
      localStorage.setItem("selected_branch_id", userData.default_branch_id.toString());
    } else {
      localStorage.setItem("selected_branch_id", "1"); // fallback to HQ
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("selected_branch_id");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
